import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, unref as _unref, normalizeClass as _normalizeClass, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-wrap"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "w-100" }
const _hoisted_4 = { class: "exam-result-card pt-3" }
const _hoisted_5 = { class: "w-100 ps-2" }
const _hoisted_6 = { class: "d-flex w-100 pb-3" }
const _hoisted_7 = { class: "w-50 d-flex justify-center align-center" }
const _hoisted_8 = { class: "d-flex justify-content-center align-center w-100" }
const _hoisted_9 = { class: "align-center text-align-center" }
const _hoisted_10 = { class: "text-h3" }
const _hoisted_11 = { class: "w-50 text-sm-start white-text d-flex flex-column justify-center align-start px-1" }
const _hoisted_12 = { class: "mt-2 text-wrap" }
const _hoisted_13 = { class: "headline" }
const _hoisted_14 = { class: "mt-1 caption" }
const _hoisted_15 = { class: "mt-2 text-wrap" }
const _hoisted_16 = { class: "caption" }
const _hoisted_17 = { class: "mt-3 mb-3 d-none" }
const _hoisted_18 = { class: "d-flex exam-result-card p-3" }
const _hoisted_19 = { class: "d-flex w-100" }
const _hoisted_20 = { class: "w-100" }
const _hoisted_21 = ["innerHTML"]

import { ref, computed, onMounted } from 'vue'
import ChartProgress from './ChartProgress.vue'
import ExamSkillReport from './ExamSkillReport.vue'
import ExamSkillItemReport from './ExamSkillItemReport.vue'
import ExamResultQuestionGroupList from './ExamResultQuestionGroupList.vue'
import Exam from '../../models/exam'
import { LETTER_FORMAT } from '../../utils/constants'
import { GroupQuestion } from '../../../api/v2/models/question'
import FbShareButton from './FbShareButton.vue'
import TwShareButton from './TwShareButton.vue'
import { footerState } from '../../stores/footer'
import UserExam from '../../models/user_exam'
import { ExamQScoreHistory } from '../../../api/v2/models/q_score_history'
import ExamEvaluationComponent from './ExamEvaluation.vue'
import SkillsChart from "./SkillsChart.vue"
import Banner from "../../../api/v2/models/banner"

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'ExamResultMobile',
  props: {
    exam: {},
    userExam: {},
    groupQuestions: {},
    banners: {},
    examQScoreHistory: {}
  },
  setup(__props: any) {

const props = __props

// Reactive Data
const active = ref(0)

// Computed
const skills = computed(() => props.exam.examSkills)

const shareUrl = computed(() => `${window.location.origin}/exams/${props.exam.id}`)

const shareText = computed(() => `
${props.userExam.passed ? '合格しました！' : '残念ながら不合格です'}
正解率: ${props.userExam.average}%\n
平均: ${props.exam.averageRate}%\n
順位: ${props.userExam.position}位\n
`)

// Functions
function getQuestionNumber(groupExamResultQuestion: GroupQuestion): number {
  return (
    props.groupQuestions
      .filter((item) => item.questions.every((question) => !question.isDescriptionQuestion))
      .indexOf(groupExamResultQuestion) + 1
  )
}

function getBanner(position: string): Banner | undefined {
  return props.banners?.find((banner) => banner.position === position)
}

// Lifecycle
onMounted(() => {
  footerState.setFooterDefault()
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (__props.userExam.finishedAt)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (getBanner('exam_result_top'))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "container p-4 container--fluid",
              innerHTML: getBanner('exam_result_top')?.bodyHtml
            }, null, 8 /* PROPS */, _hoisted_2))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createCommentVNode(" Row 1: Back Button "),
            _createElementVNode("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "result-head")
            ]),
            _createCommentVNode(" Row 2: Chart & Info "),
            _createElementVNode("div", _hoisted_6, [
              _createCommentVNode(" Chart Column "),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_v_progress_circular, {
                    class: "m-2",
                    size: 130,
                    width: 15,
                    "model-value": __props.userExam.average,
                    color: "white"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(__props.userExam.average), 1 /* TEXT */),
                        _cache[2] || (_cache[2] = _createElementVNode("div", { style: {"margin-top":"-10px"} }, "%", -1 /* CACHED */))
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["model-value"])
                ])
              ]),
              _createCommentVNode(" Info Column "),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: _normalizeClass(["exam-status-result p-1", {
            pass: __props.userExam.passed,
            failure: !__props.userExam.passed
          }])
                }, [
                  (__props.userExam.passed)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        color: "white"
                      }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createTextVNode("mdi-check", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  _createTextVNode(" " + _toDisplayString(__props.userExam.passed
              ? _ctx.$t('exam_result.pass', { format: _unref(LETTER_FORMAT).UPTITLECASE })
              : _ctx.$t('exam_result.failure', {
                format: _unref(LETTER_FORMAT).UPTITLECASE
              })), 1 /* TEXT */)
                ], 2 /* CLASS */),
                (!__props.exam.canRetest)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(__props.userExam.position), 1 /* TEXT */),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('exam_result.place')) + " ", 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_14, " / " + _toDisplayString(__props.exam.usersCount) + " " + _toDisplayString(_ctx.$t('exam_result.people')), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createTextVNode(_toDisplayString(_ctx.$t('exam_result.national_average', { format: _unref(LETTER_FORMAT).UPTITLECASE })) + ": ", 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_16, _toDisplayString(__props.exam.averageRate) + "% ", 1 /* TEXT */)
                      ])
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(FbShareButton, { url: shareUrl.value }, null, 8 /* PROPS */, ["url"]),
                  _createVNode(TwShareButton, {
                    url: shareUrl.value,
                    text: shareText.value,
                    class: "mt-1"
                  }, null, 8 /* PROPS */, ["url", "text"])
                ])
              ])
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_18, [
            _createVNode(SkillsChart, {
              skills: skills.value,
              "user-exam": __props.userExam
            }, null, 8 /* PROPS */, ["skills", "user-exam"])
          ], 512 /* NEED_PATCH */), [
            [_vShow, __props.exam.isShowEvaluation]
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_v_tabs, {
              modelValue: active.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
              color: "#16B72F",
              dark: "",
              centered: "",
              "fixed-tabs": "",
              "slider-color": "yellow",
              "icons-and-text": ""
            }, {
              default: _withCtx(() => [
                (__props.exam.isShowEvaluation)
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: 0,
                      ripple: ""
                    }, {
                      default: _withCtx(() => [
                        _cache[5] || (_cache[5] = _createTextVNode(" 評価 ", -1 /* CACHED */)),
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("comment", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true),
                _createVNode(_component_v_tab, { ripple: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.answer', { format: _unref(LETTER_FORMAT).UPTITLECASE })) + " ", 1 /* TEXT */),
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("dvr", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_tab, { ripple: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('exam_result.stats', { format: _unref(LETTER_FORMAT).UPTITLECASE })) + " ", 1 /* TEXT */),
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("pie_chart", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_tab, {
                  ripple: "",
                  class: "d-none"
                }, {
                  default: _withCtx(() => [
                    _cache[9] || (_cache[9] = _createTextVNode(" コメント ", -1 /* CACHED */)),
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode("comment", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]),
            _createVNode(_component_v_tabs_window, {
              modelValue: active.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((active).value = $event))
            }, {
              default: _withCtx(() => [
                (__props.exam.useExamEvaluation && __props.exam.examEvaluations.length > 0)
                  ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                      key: 0,
                      value: 0
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { text: "" }, {
                          default: _withCtx(() => [
                            _createVNode(ExamEvaluationComponent, {
                              examEvaluations: __props.exam.examEvaluations,
                              score: __props.userExam.average
                            }, null, 8 /* PROPS */, ["examEvaluations", "score"])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true),
                _createVNode(_component_v_tabs_window_item, {
                  value: __props.exam.useExamEvaluation && __props.exam.examEvaluations.length > 0 ? 1 : 0
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, { text: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_title, { class: "ps-2 pe-2 question-report-list" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _createVNode(_component_v_list, null, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.groupQuestions, (item, index) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, {
                                        key: index + 'group'
                                      }, [
                                        _createVNode(ExamResultQuestionGroupList, {
                                          item: item,
                                          padding: true,
                                          exam: __props.exam,
                                          "user-exam": __props.userExam,
                                          examQScoreHistory: __props.examQScoreHistory,
                                          questionNumber: getQuestionNumber(item)
                                        }, null, 8 /* PROPS */, ["item", "exam", "user-exam", "examQScoreHistory", "questionNumber"]),
                                        (index + 1 < __props.groupQuestions.length)
                                          ? (_openBlock(), _createBlock(_component_v_divider, {
                                              key: index + 'group_divider'
                                            }))
                                          : _createCommentVNode("v-if", true)
                                      ], 64 /* STABLE_FRAGMENT */))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ])
                            ])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["value"]),
                _createVNode(_component_v_tabs_window_item, {
                  value: __props.exam.useExamEvaluation && __props.exam.examEvaluations.length > 0 ? 2 : 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, { text: "" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skills.value, (skill, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            xs12: "",
                            key: index
                          }, [
                            _createVNode(ExamSkillReport, {
                              skill: skill,
                              userExam: __props.userExam,
                              mobile: true
                            }, null, 8 /* PROPS */, ["skill", "userExam"]),
                            (index + 1 < skills.value.length)
                              ? (_openBlock(), _createBlock(_component_v_divider, {
                                  key: 0,
                                  class: "m-0"
                                }))
                              : _createCommentVNode("v-if", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skill.skillItems, (skillItem, indexItem) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: index + indexItem
                              }, [
                                _createVNode(ExamSkillItemReport, {
                                  skillItem: skillItem,
                                  userExam: __props.userExam,
                                  mobile: true
                                }, null, 8 /* PROPS */, ["skillItem", "userExam"]),
                                (indexItem + 1 < skill.skillItems.length)
                                  ? (_openBlock(), _createBlock(_component_v_divider, {
                                      class: "m-0",
                                      key: index + indexItem + skillItem.id
                                    }))
                                  : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["value"]),
                _createVNode(_component_v_tabs_window_item, {
                  value: __props.exam.useExamEvaluation && __props.exam.examEvaluations.length > 0 ? 3 : 2,
                  class: "d-none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, { text: "" }, {
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "comment-body")
                      ]),
                      _: 3 /* FORWARDED */
                    })
                  ]),
                  _: 3 /* FORWARDED */
                }, 8 /* PROPS */, ["value"])
              ]),
              _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["modelValue"])
          ])
        ]),
        (getBanner('exam_result_bottom'))
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "container p-4 container--fluid",
              innerHTML: getBanner('exam_result_bottom')?.bodyHtml
            }, null, 8 /* PROPS */, _hoisted_21))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}
}

})